import React, { useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Button,
  Container,
  Paper,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextareaAutosize,
  Stack,
  Divider,
  Grid,
  Autocomplete,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  InputAdornment,
  capitalize,
  Fab,
  Chip,
} from '@mui/material';
import AppTheme from '../../../../shared-theme/AppTheme';
import { CssBaseline } from '@mui/material';
import SideMenu from '../../../../components/SideMenu';
import Header from '../../../../components/Header';
import { Add, ArrowBack, CalculateOutlined, Check, Close, SetMealSharp } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import Selector from '../../../../components/Selector';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StyledCellHeader } from '../../../../components/StyledCellHeader';
import CrearBancoDialog from '../../../configuracion/bancos/crearbancodialog';
import CrearMonedaDialog from '../../../configuracion/monedas/crearmonedadialog';
import AutocompleteWithAdd from '../../../../components/AutocompleteWithAdd';
import { fetchBancos, fetchMonedas, fetchProductosFinancieros, fetchProveedores } from '../../../../utils/generalsFetch';
import { formatIdentification, formatNumber, formatNumberWithCommas, formatPhone } from '../../../../utils/generalFunctions';
import { gray } from '../../../../shared-theme/themePrimitives';
import CobrarInicialDialog from '../iniciales/cobrarinicialdialog';
import { calculoabsoluto } from '../funciones/funciones';
import AlertMessageDialog from '../../../../components/Dialogs/alertMessageDialog';
import OnGeneralMessageDialog from '../../../../components/Dialogs/OnGeneralMessageDialog';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);


function EstadoChip({ estado }) {
  let color = 'default';
  if (estado === 'aceptada') color = 'success';
  else if (estado === 'abierta') color = 'warning';
  else if (estado === 'rechazada') color = 'error';
  return <Chip label={capitalize(estado)} color={color} textTransform="none" size='large'/>;
}


export default function DetalleSolicitud() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [openCobrarInicial, setOpenCobrarInicial] = React.useState(false);
  const [montoInicial, setMontoInicial] = React.useState(0);
  const [montoInicialText, setMontoInicialText] = React.useState("0");
  const [moneda, setMoneda] = React.useState(null);
  const [valorCuota, setValorcuotas] = React.useState(0);
  const [deudaTotal, setDeudaTotal] = React.useState(0);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [openGeneralAcceptMessageDialog, setOpenGeneralAcceptMessageDialog] = React.useState(false);
  const [openGeneralRejectMessageDialog, setOpenGeneralRejectMessageDialog] = React.useState(false);
  const [fechaSolicitud, setFechaSolicitud] = React.useState(dayjs());
  const [fechaPrestamoInicio, setFechaPrestamoInicio] = React.useState(dayjs());
  const [estadoSolicitud, setEstadoSolicitud] = React.useState("abierta");
  const [clienteId, setClienteId] = React.useState(null);


  const [financialProductSelected, setFinancialProductSelected] = React.useState(null);
  const [formulario, setFormulario] = React.useState({
    "campos": 
    [{"id": 2, "name": "Cédula / Identificación", "type": "ID", "options": [], "category": "Datos personales", "required": true, "deletelable": false}, 
    {"id": 1, "name": "Nombre completo", "type": "texto", "options": [], "category": "Datos personales", "required": true, "deletelable": false}, 
    {"id": 3, "name": "Fecha de nacimiento", "type": "fecha", "options": [], "category": "Datos personales", "required": true, "deletelable": false},
    {"id": 4, "name": "Estado civil", "type": "opciones", "options": ["Soltero", "Casado", "Divorciado", "Viudo"], "category": "Datos personales", "required": true}, 
    {"id": 1753886767728, "name": "Celular", "type": "numerotel", "options": [], "category": "Datos personales", "required": true, "deletelable": false}, 
    {"id": 5, "name": "Teléfono", "type": "numerotel", "options": [], "category": "Datos personales", "required": true, "deletelable": true}, 
    {"id": 6, "name": "Dirección residencial", "type": "texto", "options": [], "category": "Datos personales", "required": true, "deletelable": false},
    {"id": 7, "name": "Ocupación / Profesión", "type": "texto", "options": [], "category": "Información laboral", "required": true, "deletelable": true}, 
    {"id": 8, "name": "Empresa donde labora", "type": "texto", "options": [], "category": "Información laboral", "required": false, "deletelable": true}, 
    {"id": 9, "name": "Ingreso mensual", "type": "monto", "options": [], "category": "Información laboral", "required": true, "deletelable": true}, 
    {"id": 10, "name": "Monto solicitado", "type": "monto", "options": [], "category": "Datos del préstamo", "required": true, "deletelable": false}, 
    {"id": 12, "name": "Frecuencia de pago", "type": "opciones", "options": [], "category": "Datos del préstamo", "required": true, "deletelable": false}, 
    {"id": 11, "name": "Plazo del préstamo ", "type": "numero", "options": [], "category": "Datos del préstamo", "required": true, "deletelable": false}, 
    {"id": 13, "name": "Interes", "type": "numero", "options": [], "category": "Datos del préstamo", "required": false, "deletelable": true},
    {"id": 14, "name": "Mora", "type": "numero", "options": [], "category": "Datos del préstamo", "required": false, "deletelable": true},
    ], 
     "categorias": [{"id": 1, "name": "Datos personales", "deletelable": false}, 
      {"id": 3, "name": "Datos del préstamo", "deletelable": false}, 
      ]})

  const [general, setGeneral] = React.useState({"tipo": "credito_consumo", 
    "nombre": "Repuestos credito", "autorizado": false, "sucursales": ["a0e60aeb-134d-4a38-b21d-75a094703d89"], 
    "formaDePago": ["Mensual", "Quincenal"], "montoMaximo": 20000, "montoMinimo": 100, "requiereSolicitud": true, 
    "requiereInventario": true, "categoriasInventario": ["710123b4-a09e-4dbf-9ddc-6bafd0d62944"]})

  const [mora, setMora] = React.useState({"tipoMora": "fija", "valorMora": "5", "esPorcentaje": true})
  const [interes, setInteres] = React.useState({"tipoInteres": "fijo", "valorInteres": "5"});

  const [productoSelected, setProductoSelected] = React.useState(null);
  const [productos, setProductos] = React.useState([{"id": "CHS002", "costo": 28000, "precio_venta": 34000, "1751896599709": "Sí", "1752693666066": "Yamaha Crypton", "1752693674472": "Negro"}])
  const [camposInventario, setCamposInventario] = React.useState([{"id": "id", "name": "id", "type": "texto", "alias": "chasis", "options": [], "prefijo": "", "required": true, "inputValue": "", "deletelable": false}, 
    {"id": "costo", "name": "Costo", "type": "monto", "alias": "", "options": [], "prefijo": "", "required": true, "inputValue": "", "deletelable": false}, 
    {"id": "precio_venta", "name": "Precio de venta", "type": "monto", "alias": "", "options": [], "prefijo": "", "required": true, "inputValue": "", "deletelable": false}, 
    {"id": 1751896599709, "name": "usado", "type": "opciones", "alias": "", "options": ["si", "no"], "prefijo": "", "required": false, "inputValue": "", "deletelable": true},
    {"id": 1752693666066, "name": "Modelo", "type": "texto", "alias": "", "options": [], "prefijo": "", "required": false, "inputValue": "", "deletelable": true},
    {"id": 1752693674472, "name": "Color", "type": "texto", "alias": "", "options": [], "prefijo": "", "required": false, "inputValue": "", "deletelable": true}])

  const [formValues, setFormValues] = React.useState({})
  const [errors, setErrors] = React.useState({});
  const [productosFinancieros, setProductosFinancieros] = React.useState([]);

  useEffect(() => {
    fetchMonedas({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setMoneda(data.find((moneda) => moneda.value == "1"));
    });
    fetchProductosFinancieros({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setProductosFinancieros(data);
      fetchSolicitud(data);
    });

  }, []);



  useEffect(() => {
    var data = calculoabsoluto(formValues[10],formValues[11],formValues[13],formValues[12]);
    setDeudaTotal(data["deuda"]);
    setValorcuotas(data["cuotas"]);
  },[formValues])

  const handleInputChange = (id, value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [id]: value,
    }));

    if(value != "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [id]: undefined, 
      }));
    }
    else{
      if( formulario.campos.find(campo => campo.id == id)?.required) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [id]: `${formulario.campos.find(campo => campo.id == id).name} es requerido`, 
        }));
      }
    }
    
    var calculo = 0
    var error = undefined
    switch (id) {
      case "precio_venta": 
        calculo = parseFloat(value) - parseFloat(montoInicial);
        var error = undefined
        break;
      case "inicial":
        calculo = parseFloat(formValues["precio_venta"]) - parseFloat(value);
        break;
      default:
        return;
    }
    if (calculo < general.montoMinimo ||calculo > general.montoMaximo) {
      error = `Monto debe ser entre ${moneda?.label+"$"+formatNumberWithCommas(general.montoMinimo.toFixed(2))} - ${moneda?.label+"$"+formatNumberWithCommas(general.montoMaximo.toFixed(2))}`
    }
    setFormValues((prevValues) => ({
      ...prevValues,
      [10]: calculo,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [10]: error,
    }));




  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    formulario.campos.forEach((campo) => {
      if (campo.required && !formValues[campo.id]) {
        newErrors[campo.id] = `${campo.name} es requerido`;
        isValid = false;
      } else {
        newErrors[campo.id] = undefined
      }
    });
    if(general.requiereInventario && !productoSelected) {
      newErrors["producto"] = "Producto es requerido";
      isValid = false;
    }
    else{
      newErrors["producto"] = undefined;
      camposInventario.forEach((campo) => {
        if (campo.required && !formValues[campo.id]) {
          newErrors[campo.id] = `${campo.name} es requerido`;
          isValid = false;
        }
        else {
          newErrors[campo.id] = undefined
        }
      });
    }
    if (formValues[10] < general.montoMinimo || formValues[10] > general.montoMaximo) {
      newErrors[10] = `Monto debe ser entre ${moneda?.label+"$"+formatNumberWithCommas(general.montoMinimo.toFixed(2))} - ${moneda?.label+"$"+formatNumberWithCommas(general.montoMaximo.toFixed(2))}`;
      isValid = false;
    }


    setErrors(newErrors);
    return isValid;
  
  }

  const fetchSolicitud = async (productosFinancieros) => {
    var url = `${process.env.REACT_APP_SERVER_URL}/api/solicitudes-prestamo/detalle/${id}`;
    var response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
      }
    });
    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      return;
    }
    var solicitud = await response.json();
    setFechaSolicitud(dayjs.utc(solicitud.created_at));
    setFechaPrestamoInicio(dayjs.utc(solicitud.fecha_inicio_prestamo));
    setFormValues(JSON.parse(solicitud.campos));
    setEstadoSolicitud(solicitud.estado);
    setClienteId(solicitud.id_cliente);
    onProductoFinancieroChange(solicitud.id_productofinanciero,productosFinancieros,solicitud);
  }


  const onProductoFinancieroChange = async(e,productosFinancieros,solicitud) => {
    var producto = productosFinancieros.find(producto => producto.idprodfinanciero === e);

    setFinancialProductSelected(producto.idprodfinanciero);
    setGeneral(JSON.parse(producto.generales));
    setFormulario(JSON.parse(producto.formulario));
    setCamposInventario(JSON.parse(producto.fields));
    setMora(JSON.parse(producto.mora));
    setInteres(JSON.parse(producto.interes));

//    setFormValues({13: JSON.parse(producto.interes).tasa,14:JSON.parse(producto.mora).valorMora})



    let url = `${process.env.REACT_APP_SERVER_URL}/api/productos/${localStorage.getItem('idcompany')}/${producto.id}?estado=vendido`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
  
      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        return;
      }

      var data = await response.json();
      setProductos(data);
      setProductoSelected(data.productos.find(producto => producto.id == JSON.parse(solicitud.campos)["id"]));
      setMontoInicial(data.productos.find(producto => producto.id == JSON.parse(solicitud.campos)["id"])["monto_inicial"]);
      
  
    } catch (error) {
      console.log(error)
      throw error;
    }
  }

  const handleAcceptSolicitud = async() => {
    setOpenGeneralAcceptMessageDialog(false);  
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/solicitudes-prestamo/${id}`,{
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          estado: 'aceptada',
          idcompany: localStorage.getItem('idcompany'),
          id_sucursal: localStorage.getItem('id_sucursal'),
          monto_solicitado: formValues[10],
          monto_inicial: formValues[11],
          capital: formValues[12],
          interes: formValues[13],
          capPagado: formValues[14],
        })
      });
      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        return;
      }
      const data = await response.json();
      var url = `${process.env.REACT_APP_SERVER_URL}/api/prestamos`;
      var dataPrestamo = {
        "idcompany": localStorage.getItem('idcompany'),
        "id_solicitud": id,
        "id_sucursal": localStorage.getItem('id_sucursal'),
        "id_cliente": clienteId,
        "monto_inicial": formValues[11],
        "monto_solicitado": formValues[10],
        "interes": formValues[13],
        "mora": formValues[14],
        "frecuencia": formValues[12],
        "metodo": interes.tipoInteres,
        "plazo": formValues[11],
        "producto":general.requiereInventario?formValues["id"]:"no_requiere_inventario",
        "precio_venta":general.requiereInventario?formValues["precio_venta"]:0,
        "fecha_inicio": fechaPrestamoInicio ? dayjs(fechaPrestamoInicio).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
        "mora_porcentaje": mora.esPorcentaje ? mora.valorMora : 0.00,
        "created_by": localStorage.getItem('id')
      
      }
      var responsePrestamo = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify(dataPrestamo )
      }); 
      if (!responsePrestamo.ok) {
        const error = await responsePrestamo.json();
        console.log(error)
        return;
      } 
//      const dataPrestamo = await responsePrestamo.json();
//      console.log(dataPrestamo);

      setOpenAlert(true);
      setEstadoSolicitud("aceptada");
    } catch (error) {
      console.log(error);
    }
  }

  const handleRejectSolicitud = async() => {
    setOpenGeneralRejectMessageDialog(false);
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/solicitudes-prestamo/${id}`,{
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          estado: 'rechazada'
        })
      });
      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        return;
      }
      const data = await response.json();
      console.log(data);
      setOpenAlert(true);
      setEstadoSolicitud("rechazada");

    } catch (error) {
      console.log(error);
    }
  }


  return (
    <Box>
      <AlertMessageDialog message={`La solicitud de prestamo se ha aceptado con exito.`} title={''} severity={"success"} color={"success"} open={openAlert} handleClose={()=>{setOpenAlert(false);}}/>
      

      <AppTheme themeComponents={{}}>
        <OnGeneralMessageDialog open={openGeneralAcceptMessageDialog} onClose={()=>{setOpenGeneralAcceptMessageDialog(false)}} title={"Confirmar"} message={"Deseas aceptar la solicitud de prestamo?"} buttonText={"Confirmar"} onRegister={()=>{handleAcceptSolicitud()}}/>
        <OnGeneralMessageDialog open={openGeneralRejectMessageDialog} onClose={()=>{setOpenGeneralRejectMessageDialog(false)}} title={"Confirmar"} message={"Deseas rechazar la solicitud de prestamo?"} buttonText={"Confirmar"} onRegister={()=>{handleRejectSolicitud()}}/>

        <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex' }}>
          <SideMenu />
          <Box component="main" sx={{ flexGrow: 1, overflow: 'auto' }}>
              <Stack
                  spacing={2}
                  sx={{
                  alignItems: 'center',
                  mx: 3,
                  pb: 5,
                  mt: { xs: 8, md: 0 },
                  }}>

                  <Header parent={"Gestion Comercial"} child={"Prestamos"} />
                  <Container maxWidth={"xl"} sx={{ px: { xs: 2, md: 10 }, py: 5, display: "flex", justifyContent: "center", flexDirection: "column", backgroundColor: "transparent"}}>
                      <Box dividers display={"flex"} justifyContent={"flex-start"} alignItems={"center"} >
                          <Button variant="outlined" startIcon={<ArrowBack/>} onClick={()=>{navigate(-1)}}>Atras</Button>
                          <Box display={"flex"} flexDirection={"column"} gap={2} ml={5} flex={1}>
                              <Typography variant="h4" fontWeight={700} textAlign={"left"}>Detalles de la solicitud</Typography>
                              <Typography variant="body1" color="text.secondary" textAlign={"left"} sx={{mt:-1}}>Detalles de la solicitud de prestamo</Typography>
                          </Box>
                          <Box sx={{ ml: 2 }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                disabled={true}
                                label="Fecha de Solicitud"
                                value={fechaSolicitud}
                                format="DD/MM/YYYY"
                                slotProps={{
                                  textField: {
                                    size: 'small',
                                    sx: { minWidth: 200 }
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </Box>
                      </Box>

                      { financialProductSelected && (
                          <Grid container spacing={3}>
                            <Grid item size={12}>
                              <Box boxShadow={1} p={2} borderRadius={3} mt={2} padding={5}>
                                  <Selector
                                    sx={{marginTop:2}}
                                    disabled={true}
                                    value={financialProductSelected}
                                    onChange={(e) => onProductoFinancieroChange(e)}
                                    options={productosFinancieros.map(producto => ({label:JSON.parse(producto.generales).nombre,value:producto.idprodfinanciero}))}
                                    placeholder="Tipo de producto"/>
                                  <Grid container spacing={2} mt={2}>
                                    <Grid item size={12}>
                                      <Typography fontSize={16} fontWeight={600} textAlign={"left"}>Nombre</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{general.nombre}</Typography>
                                    </Grid>
                                    <Grid item size={6}>
                                      <Typography fontSize={16} fontWeight={700} textAlign={"left"}>Monto Minimo</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{moneda?.label}${formatNumberWithCommas(general.montoMinimo.toFixed(2))}</Typography>
                                    </Grid>
                                    <Grid item size={6}>
                                      <Typography fontSize={16} fontWeight={700} textAlign={"left"}>Monto Maximo</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{moneda?.label}${formatNumberWithCommas(general.montoMaximo.toFixed(2))}</Typography>
                                    </Grid>
                                    <Grid item size={6}>
                                      <Typography fontSize={16} fontWeight={700} textAlign={"left"}>Interes</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{interes.tipoInteres} {interes.tasa}%</Typography>
                                    </Grid>
                                    <Grid item size={6}>
                                      <Typography fontSize={16} fontWeight={700} textAlign={"left"}>Mora</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{mora.tipoMora} {mora.valorMora} {mora.esPorcentaje ? "%" : ""}</Typography>
                                    </Grid>
                                    <Grid item size={6}>
                                      <Typography fontSize={16} fontWeight={700} textAlign={"left"}>Requiere Solicitud?</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{general.requiereSolicitud ? "Si" : "No"}</Typography>
                                    </Grid>
                                    <Grid item size={6}>
                                      <Typography fontSize={16} fontWeight={700} textAlign={"left"}>Requiere Autorizacion si no cumple parametros?</Typography>
                                      <Typography variant="body1" color="text.secondary" textAlign={"left"}>{general.autorizado ? "Si" : "No"}</Typography>
                                    </Grid>

                                  </Grid>
                                </Box>
                                    
                                {formulario.categorias.map((categoria) => {
                                    var camposCategoria = formulario.campos.filter(campo => campo.category === categoria.name);
                                    
                                    return (
                                      <>
                                      {categoria.id==3 && general.requiereInventario && (
                                      <Box boxShadow={1} p={2} borderRadius={3} mt={2} padding={5}>
                                        <Grid container spacing={2}>
                                            <Grid item size={12}>
                                                <Typography variant="h6" fontWeight={700} textAlign={"left"}>{capitalize(camposInventario[0].alias + " para financiamiento")}</Typography>
                                                <Typography textAlign={"left"} mx={1} fontSize={12} color="error">{errors["producto"]}</Typography>
                                                
                                            </Grid>
                                            {productoSelected && camposInventario.map((campo,index) => {
                                              var value = JSON.parse(productoSelected.campos)[campo.id];
                                              
                                              return(
                                                <>
                                              <Grid item size={4} key={campo.id}>
                                                <Typography fontWeight={600} textAlign={"left"} mx={1}>{campo.id=="id"?capitalize(campo.alias):capitalize(campo.name)}</Typography>
                                                <TextField
                                                  slotProps={{
                                                    input: {
                                                      startAdornment:campo.type === 'monto' ? (
                                                        <InputAdornment position="start">{moneda?.label}$</InputAdornment>
                                                      ) : null,
                                                    },
                                                  }}
                                                  error={errors[campo.id]!=undefined? true : false}
                                                  helperText={errors[campo.id]}
                                                  fullWidth
                                                  value={campo.type=="numero" || campo.type=="monto"?formatNumberWithCommas(formValues[campo.id]?.toString()): value}
                                                  onChange={(e) => {
                                                    var newValue = parseInt(e.target.value.replaceAll(/,/g, ''));
                                                    handleInputChange(campo.id, newValue);
                                                  }}
                                                  disabled={true}
                                                  />
                                              </Grid>
                                              {index == camposInventario.length-1 && (
                                                <Grid item size={4}>
                                                  <Typography fontWeight={600} textAlign={"left"} mx={1}>Inicial</Typography>
                                                  <TextField
                                                    slotProps={{
                                                      input: {
                                                        startAdornment: <InputAdornment position="start">{moneda?.label}$</InputAdornment>,
                                                      },
                                                    }}
                                                    fullWidth
                                                    value={formatNumberWithCommas(montoInicial)}
                                                    disabled={true}
                                                  />

                                                </Grid>
                                              )}
                                              </>
                                              )
                                            })}
                                        </Grid>
                                      </Box>
                                    )}
                                    <Box boxShadow={1} p={2} borderRadius={3} mt={2} padding={5}>
                                        <Grid container spacing={2}>
                                            <Grid item size={12}>
                                                <Typography variant="h6" fontWeight={700} textAlign={"left"}>{categoria.name}</Typography>
                                            </Grid>
                                            {camposCategoria.map((campo) => {
                                              var helper = ""
                                              switch (campo.id) {
                                                case 10:
                                                  helper = `Monto debe ser entre ${moneda?.label+"$"+formatNumberWithCommas(general.montoMinimo.toFixed(2))} - ${moneda?.label+"$"+formatNumberWithCommas(general.montoMaximo.toFixed(2))}`;
                                                  break;
                                                case 13:
                                                  helper = "Interes mensual de tipo "+interes.tipoInteres+" "+interes.tasa+"%";
                                                  break;
                                                case 14:
                                                  var esPorcentaje = mora.esPorcentaje ? " %" : "";
                                                  helper = "Mora de tipo "+mora.tipoMora+" "+mora.valorMora+esPorcentaje;
                                                  break;  
                                              }

                                              var type = campo.type;
                                              if (campo.id == 10 && formValues["10"] != undefined) {
                                                //alert(JSON.stringify(formValues["10"]))
                                              }

                                                return (
                                                    <Grid item size={4} key={campo.id}>
                                                      <Typography fontWeight={600} textAlign={"left"} mx={1} color={"textSecondary"}>{campo.name}</Typography>
                                                      {campo.type === "ID" && (
                                                            <TextField
                                                                fullWidth
                                                                error={errors[campo.id]!=''? true : false}
                                                                helperText={errors[campo.id]}
                                                                placeholder={campo.name}
                                                                value={formatIdentification(formValues[campo.id]?formValues[campo.id]:'') || ''}
                                                                onChange={(e) => {
                                                                    handleInputChange(campo.id, e.target.value);
                                                                }}
                                                                required={campo.required}
                                                                disabled={true}
                                                            />
                                                        )}

                                                        {campo.type === "texto" && (
                                                            <TextField
                                                                fullWidth
                                                                error={errors[campo.id]!=''? true : false}
                                                                helperText={errors[campo.id]}
                                                                placeholder={campo.name}
                                                                value={formValues[campo.id] || ''}
                                                                onChange={(e) => {
                                                                    handleInputChange(campo.id, e.target.value);
                                                                }}
                                                                required={campo.required}
                                                                disabled={true}
                                                            />
                                                        )}
                                                        {campo.type === "numerotel" && (
                                                            <TextField
                                                                fullWidth
                                                                error={errors[campo.id]!=undefined? true : false}
                                                                helperText={errors[campo.id]}
                                                                placeholder={campo.name}
                                                                value={formatPhone(formValues[campo.id]) || ''}
                                                                onChange={(e) => {
                                                                    handleInputChange(campo.id, e.target.value);
                                                                }}
                                                                required={campo.required}
                                                                disabled={true}
                                                            />
                                                        )}
                                                        {campo.type === "fecha" && (
                                                            <TextField
                                                                fullWidth
                                                                placeholder={campo.name}
                                                                error={errors[campo.id]!=undefined? true : false}
                                                                helperText={errors[campo.id]}
                                                                type="date"
                                                                value={formValues[campo.id] || ''}
                                                                onChange={(e) => {
                                                                    handleInputChange(campo.id, e.target.value);
                                                                }}
                                                                required={campo.required}
                                                                disabled={true}
                                                            />
                                                        )}
                                                        {campo.type === "monto" && (
                                                        <TextField
                                                            slotProps={{
                                                                input: {
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">{moneda?.label}$</InputAdornment>
                                                                    ),
                                                                },
                                                            }}
                                                            helperText={helper}
                                                            error={errors[campo.id]!=undefined? true : false}
                                                            fullWidth
                                                            disabled={campo.id === 10 && general.requiereInventario? true : false}
                                                            placeholder={campo.name}
                                                            value={formatNumberWithCommas(formValues[campo.id]?.toString()) || ''}
                                                            onChange={(e) => {
                                                                var value = parseInt(e.target.value.replaceAll(/,/g, ''));
                                                                handleInputChange(campo.id,value);
                                                            }}
                                                            required={campo.required}/>
                                                          )  
                                                        }
                                                        

                                                        {campo.type === "numero" && (
                                                            <TextField
                                                              helperText={helper!="" ? helper : errors[campo.id]}
                                                              error={errors[campo.id]!=undefined? true : false}
                                                              fullWidth
                                                              placeholder={campo.name}
                                                              type="number"
                                                              value={formValues[campo.id] || ''}
                                                              onChange={(e) => {
                                                                  handleInputChange(campo.id, e.target.value);
                                                              }}
                                                              required={campo.required}
                                                              disabled={true}
                                                            />
                                                          
                                                        )}
                                                        {campo.type === "opciones" && (
                                                            <FormControl fullWidth>
                                                                <Selector
                                                                    helperText={errors[campo.id]}
                                                                    error={errors[campo.id]!=undefined? true : false}
                                                                    value={formValues[campo.id] || ''}
                                                                    onChange={(e) => {
                                                                      handleInputChange(campo.id, e.target.value);
                                                                    }}
                                                                    options={campo.options.map(option => ({ label: option, value: option }))}
                                                                    placeholder={campo.name}
                                                                    disabled={true}
                                                                    />

                                                            </FormControl>
                                                        )}
                                                    </Grid>
                                                );
                                            
                                            })}

                                        </Grid>
                                        
                                        
                                    </Box>
                                    </>
                                    )
                                })}
                                <Box display={"flex"} flexDirection={"row"} sx={{position: 'fixed', bottom: 0, left: 0, width: '100%', bgcolor: 'white', p: 2, borderTop: '1px solid #eee'}}>
                                  <Box sx={{mx:"auto"}}>
                                    <Button variant="outlined"  sx={{maxWidth:200,fontWeight:"bold", marginRight:5,  borderColor:"primary.main"}}>Cuota: {moneda?.label}${formatNumberWithCommas(valorCuota)}</Button>
                                    <Button variant="outlined"  sx={{maxWidth:250,fontWeight:"bold", marginRight:5,  borderColor:"primary.main"}}>Deuda Total: {moneda?.label}${formatNumberWithCommas(deudaTotal)}</Button>
                                  </Box>
                                  <Box sx={{  textAlign: 'right', }}>                       
                                    {estadoSolicitud === "abierta" ? (
                                      <>
                                        <Button variant='outlined' startIcon={<ArrowBack/>} sx={{width:200,fontWeight:"bold", marginRight:5}} onClick={() => navigate(-1)}>Cancelar</Button>
                                        <Button variant="contained" startIcon={<Close/>} color="error" sx={{width:200,fontWeight:"bold", marginRight:5}} onClick={() => setOpenGeneralRejectMessageDialog(true)}>Rechazar Solicitud</Button>
                                        <Button variant="contained" startIcon={<Check/>} color="primarybutton" sx={{width:200,fontWeight:"bold", marginRight:5}} onClick={() => setOpenGeneralAcceptMessageDialog(true)}>Aceptar Solicitud</Button>
                                      </>
                                    ) : (
                                      <Box  marginTop={2} marginRight={10}>
                                        <EstadoChip estado={estadoSolicitud} />
                                      </Box>
                                    )}
                                  </Box>
                                </Box>
                            </Grid>
                          </Grid>
                      )}
                  </Container>
            </Stack>
          </Box>
        </Box>
      </AppTheme>
    </Box>
  );
}
